<script>
    import { onMount } from 'svelte';
    // import FroalaEditor from 'froala-editor';
    // import 'froala-editor/js/plugins/align.min.js';
    // import 'froala-editor/js/plugins/emoticons.min.js';
    import Quill from 'quill';
    import 'quill-emoji/dist/quill-emoji.js';
    let Delta = Quill.import('delta');
    import Block from "quill/blots/block";
    let Embed = Quill.import('blots/block/embed');



    let quill;
    let showEntries = false;
    let content = {
        delta: null,
        text: null,
        html: null
    }
    onMount(() => {
        /*Build Froala*/
        // new FroalaEditor('#editor', {
        //     toolbarButtons: {
        //     'moreText': {
        //         'buttons': ['bold', 'italic', 'underline', 'strikeThrough']
        //     },
        //     'moreParagraph': {
        //         'buttons': ['emoticons']
        //     }
        //     }

        // })

class Clickables extends Embed {
    static create(value) {
        let node = super.create(value);
        node.innerHTML = value.Name;
        node.setAttribute("spellcheck", false);

        //node.setAttribute('style', `border-bottom: 1px solid`);
       node.classList.add(`bg-${value.Color}`);
       node.addEventListener('click',function(event) {
           console.log(event);
            console.log("ClickableSpan was clicked. Blot: ", value);
            showInlineActiveBuildingBLocksSelector(value.Color == 'pain' ? 1 : 0, event);
     
        });
        return node;
    }
}

Clickables.blotName = 'span'; 
Clickables.className = 'clickables';//now you can use .clickables classname in your toolbar
Clickables.tagName = 'span';
Quill.register({
    'formats/span': Clickables
});

        /*Build quill with emojicons*/
            const toolbarOptions = {
                container: [
                    ['bold', 'italic', 'underline', 'strike'],
                    ['emoji'],   
                ],
                handlers: {'emoji': function() {}}
            }
             
            quill = new Quill('#textEditor', {
                modules: {
                    // ...
                    toolbar: toolbarOptions,
                    "emoji-toolbar": true
                    // "emoji-textarea": true,
                    // "emoji-shortname": true,
                },
                theme: 'snow'
            });
            
            quill.on('text-change', function(delta, oldDelta, source) {
                    if (source == 'api') {
                        //console.log("An API call triggered this change.");
                    } else if (source == 'user') {
                        
                        //console.log("A user action triggered this change.");
                    }
                    console.log(quill.getContents());
                    content.delta = delta;
                    content.text = quill.getText();
                    content.html = quill.root.innerHTML;
                });

        });
      
    let buildingBlocks = [
        { Name: "Benefits", Color: 'benefit', Entries:[
                    {Value: 21, Name: 'BenefitsLorem Ipsum 1', Color: 'benefit'},
                    {Value: 22, Name: 'Benefits Lorem Ipsum 2', Color: 'benefit'},
                    {Value: 23, Name: 'Benefits Lorem Ipsum 3', Color: 'benefit'}

                ]},
                 {Name: "Pains", Color: 'pain', Entries:[
                    {Value: 11, Name: 'Pains Ipsum Lorem 1', Color: 'pain'},
                    {Value: 12, Name: 'Pains Ipsum Lorem 2', Color: 'pain'},
                    {Value: 13, Name: 'Pains Ipsum Lorem 3',Color: 'pain'}

                ]}

            ]

let activeBuildingBlock = [];
let usedbuildingBlocks = [];

function showInlineActiveBuildingBLocksSelector(index, event){
        event.stopPropagation();
        console.log(event);
    activeBuildingBlock = buildingBlocks[index];
    showEntries = true;
    setTimeout(()=>{
       var menu = document.getElementById('clickableEntriesMenu');
            menu.setAttribute('style', `top:${event.clientY}px; left:${event.clientX}px;`)
    },10)
}
    let hovering = false;

	export function dragstart (ev, entry) {
        ev.dataTransfer.effectAllowed = 'copy';
        ev.dataTransfer.dropEffect = 'copy';
        let obj = entry
        ev.dataTransfer.setData('text/plain', JSON.stringify(obj));
        };

	export function drop (ev) {
        ev.dataTransfer.dropEffect = 'copy';
        let json_obj = ev.dataTransfer.getData("text/plain");

         let obj = null;
         if(json_obj == null || json_obj == '')
            return;
         
         obj = JSON.parse(json_obj);
         console.log(obj);
            setTimeout(()=>{
                    console.log(quill);
                    quill.deleteText(getRange().index, getRange().length); //We have to remove the original dropped object

                    quill.focus();

                    //    quill.updateContents(
                    //     new Delta()
                    //         .retain(getRange())
                    //         .insert('span', { 
                    //         attribute: obj.Value
                    //     })
                    // );
                    quill.insertEmbed(getRange().index,"span", obj);

            },1)
    


    };
        /*Possible wy to highlight stuff*/
        //https://github.com/reedsy/quill-cursors#readme

    function getRange(){
        var range = quill.getSelection();
        if (range) {
        // if (range.length == 0) {
        //     console.log('User cursor is at index', range.index);            
        //     return range.index;
        // }
        // } else {
        //     var text = quill.getText(range.index, range.length);
        //     console.log('User has highlighted: ', text);
        //     return range.index;

        // }
         return range;
        } else {
            console.log('User cursor is not in editor');
            return null
        }
    }

   function windowOnClick(e){
       if(showEntries)
            showEntries = false;
           }

           function changeItem(event, entry){
               alert(`you want to change this entry to ${entry.Name}`)

           }
</script>
<svelte:window on:click|preventDefault={event => windowOnClick(event)}/>

<h1 class="px-4">Quill</h1>

<div class="flex flex-row">
    <div class="flex-auto p-4" on:drop={event => drop(event)} ondragover>
            <!-- Create the editor container -->
            <div id="textEditor"></div>
    </div>
    <div class="flex-none p-4">
        <div>
            {#each buildingBlocks as item, g}
                <div class="border-2">
                    <div class="text-{item.Color}">{item.Name}</div>
                        <ul>
                            {#each item.Entries as entry, i}
                                <li class="p-2" 
                                    draggable={true} 
			                        on:dragstart={event => dragstart(event, entry)}>
                                    {entry.Name}
                                </li>
                            {/each}
                        </ul>
                </div>
            {/each}
        </div>
    </div>
</div>
{#if showEntries}
 <div id="clickableEntriesMenu" class="absolute shadow-2xl bg-white">
        <h2 class="text-{activeBuildingBlock.Color}">{activeBuildingBlock.Name}</h2>
       <ul>
        {#each activeBuildingBlock.Entries as entry}
            <li class="p-2" on:click|preventDefault={event => changeItem(event, entry)}>
                {entry.Name}
            </li>
        {/each}
        </ul>
</div>
{/if}

<!--OUTPUT-->

<div class="flex flex-row">
        <div class="w-1/2 p-4 border-3">
        {content.text}</div>
    <div class="w-1/2 p-4 border-3">
    {content.html}</div>
</div>

<!-- <h1 class="px-4 pt-4">Froala</h1>
<div class="flex flex-row">

    <div class="flex-auto p-4">
            <div id="editor">
            </div>
    </div>
    <div class="flex-none p-4">
        Some content for drag and drop
    </div>
</div> -->


<style>
  
</style>